import { type FunctionComponent } from 'react';
import { Rating } from '../../../product-components/rating/rating.component';

export type ReviewStarRatingProps = {
	reviewCount: number;
	ratingValue: number;
	productUrl: string;
	abbreviatedReviewCount?: boolean;
	readOnly?: boolean;
};

export const ReviewStarRating: FunctionComponent<ReviewStarRatingProps> = ({
	reviewCount,
	ratingValue,
	productUrl,
	abbreviatedReviewCount = true,
	readOnly = false
}) => {
	return (
		<div className={'flex flex-wrap min-h1'}>
			{reviewCount > 0 && (
				<Rating
					ratingValue={ratingValue}
					url={`${productUrl}#reviews`}
					reviewCount={reviewCount}
					abbreviatedReviewCount={abbreviatedReviewCount}
					readOnly={readOnly}
				/>
			)}
		</div>
	);
};
